exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.img-cell img {\n  height: 100px;\n}\n\nspan.title {\n  padding-right: 25px;\n}\n\n.page-header--padding {\n  padding: 16px;\n}\n\n.promo-type-select span {\n  width: 500px;\n}\n\ndiv.k-animation-container {\n  z-index:9999 !important;\n}\n.collapse-container {\n  padding: 16px;\n}\n\n.promotions .modal-header {\n  padding: 1rem 1rem 1rem 0;\n}\n\n.promotions .modal-header .close {\n  padding: 0rem 1rem;\n}\n\n\n.modal-row,\n.modal-row-container {\n  width: 100%;\n}\n\n.modal-row-container {\n  display: flex;\n}\n\n.modal-col-1 {\n  width: 50%;\n  margin-right: 1rem;\n}\n\n.modal-col-2 {\n  width: 50%;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/pages/promotions/styles.css
// module id = 2667
// module chunks = 29